import { API_URL } from '../../shared/actions'
import { customReducer } from './customReducer'

export const auditQuestionReducer = (state, action) => {
  const {
    AUDITQUESTION: { GET_ALL_AUDITQUESTION, ADD_AUDITQUESTION, EDIT_AUDITQUESTION, DELETE_AUDITQUESTION },
  } = API_URL

  return customReducer(state, action, 'auditQuestions', [GET_ALL_AUDITQUESTION, ADD_AUDITQUESTION, EDIT_AUDITQUESTION, DELETE_AUDITQUESTION])
}

export const taskReducer = (state, action) => {
  const {
    TASK: { GET_ALL_TASK, ADD_TASK, EDIT_TASK, DELETE_TASK },
  } = API_URL

  return customReducer(state, action, 'tasks', [GET_ALL_TASK, ADD_TASK, EDIT_TASK, DELETE_TASK])
}

export const auditTaskReducer = (state, action) => {
  const {
    AUDIT_TASK: { GET_ALL_AUDIT_TASK, ADD_AUDIT_TASK, EDIT_AUDIT_TASK, DELETE_AUDIT_TASK },
  } = API_URL

  return customReducer(state, action, 'auditTasks', [GET_ALL_AUDIT_TASK, ADD_AUDIT_TASK, EDIT_AUDIT_TASK, DELETE_AUDIT_TASK])
}
